module.exports = __webpack_public_path__ + "img/google.f2aac3c5.png";